import { postRequestMall } from './request/request'
import {
  GameAwardInfoType,
  GameConfigItem,
  GameInitType,
  GameItemType,
  GameServerItemType,
  GameSubItemType, IGamePrivateArea
} from "./types/gameTypes";
import { FormDataType } from '@/@types/types'

// 游戏列表
export const apiGameList = (params?: any) => postRequestMall<GameItemType[]>('/game/list', params)

// 游戏区服列表
export const apiGameServerList = (params?: any) =>
  postRequestMall<GameServerItemType[]>('/game/role/serverList', params)

// 获取支付列表
export const apiGetPayList = (params?: any) => postRequestMall('/pay/list', params, false, false)

// 再来一单
export const apiHandleRepay = (params?: any) =>
  postRequestMall('/order/rePay', params, false, false)

// 检查商品状态和数量
export const apiCheckGoodsStatus = (params?: any) =>
  postRequestMall('/order/skuCheck', params, false, true)

// 领取免费礼包
export const apiDirectGift = (params?: any) =>
  postRequestMall('/order/directGift', params, false, false)

// 绑定邮箱手机号/ 获取邮箱验证码 不传verifyCode表示获取验证码
export const apiEmailBind = (params?: any) =>
  postRequestMall('/game/role/emailBind', params, false, true)

// 授权验证
export const apiOpyVerify = (params?: any) =>
  postRequestMall('order/optVerify', params, false, true)

// 游戏初始化配置接口
export const apiGameInit = (params?: any) =>
  postRequestMall<GameInitType>('/game/init', params, false, true)

// 限时返利详情
export const apiGameAwardInfo = (params?: any) =>
  postRequestMall<GameAwardInfoType>('/game/awardInfo', params, false, true)

// 领取限时返利奖励
export const apiGameReceiveAward = (params?: any) =>
  postRequestMall('/game/receiveAward', params, true, true)

// 获取首页游戏配置
export const apiGetGameHomeConfig = () =>
  postRequestMall<GameConfigItem[]>('/game/gatherList', {}, false, true)

// 获取角色列表（摸鱼社内使用 国内）
export const apiGameRoles = (params?: any) =>
  postRequestMall('/game/role/roles', params, false, true)

// 拉取小号列表（国内/海外）
export const apiGameSubList = (params?: any) =>
  postRequestMall<GameSubItemType[]>('/game/role/roleLogin', params, false, true)

// 根据IP获取国家(海外接口)
export const apiGameCountry = () => postRequestMall('/game/role/ipRegion', {})

// 获取当前游戏配置了哪些地区的支付方式
export const apiGameGetPayRegions = (params?: any) =>
  postRequestMall<string[]>('/pay/regions', params)

// 根据ri获取用户信息
export const apiGameGetRiInfo = (params?: any) =>
  postRequestMall<FormDataType>('/game/role/getRoleByLink', params)

// 获取账号角色列表
export const apiGetUserAllRoles = (params?: any) =>
  postRequestMall<any>('/game/role/userAllRoles', params)

// 获取私域地质
export const apiGetPrivateDomain = (params?: any) =>
  postRequestMall<IGamePrivateArea[]>('/game/role/getPrivateLink', params)
